import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function Startup() {
  

  const navigate = useNavigate();
  const { user, profile, loading } = useAuth();
  const redirected = useRef(false);

  useEffect(() => {
  

    if (loading || redirected.current) return;

    redirected.current = true;

    if (!user) {
      navigate("/auth", { replace: true });
    } else if (!profile || !profile.onboarding_complete) {
      navigate("/onboarding", { replace: true });
    } else {
      navigate("/dashboard", { replace: true });
    }
  }, [user, profile, loading, navigate]);

  return (
    <div className="h-screen flex items-center justify-center bg-white">
      <div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}



{/*
  
  import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";

export default function Startup() {
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      // Check if user logged in
      const { data: auth } = await supabase.auth.getUser();

      if (!auth.user) {
        navigate("/auth"); // No user → go to login
        return;
      }

      // Fetch onboarding status from profiles table
      const { data: profile } = await supabase
        .from("profiles")
        .select("onboarding_complete")
        .eq("id", auth.user.id)
        .single();

      // If onboarding not finished → show onboarding
      if (profile?.onboarding_complete === false) {
        navigate("/onboarding");
      } else {
        navigate("/dashboard"); // Otherwise go to dashboard
      }
    };

    load();
  }, []);

  return null;
}

  
  */}